// apps/web/src/components/landing-v2/ThemeSection.tsx
import type { ReactNode } from 'react'

type Props = {
  id: string
  eyebrow: string
  title: string
  lede?: string
  children: ReactNode
}

/** Section wrapper for a theme block on landing v2. Renders a header
 *  (eyebrow + italic display title + optional lede) above a 12-col
 *  responsive grid that lays out `<ProofCard>` children. The `id` is the
 *  stable anchor used by nav links and Playwright assertions. */
export function ThemeSection({ id, eyebrow, title, lede, children }: Props) {
  return (
    <section
      id={id}
      className="mx-auto max-w-[1280px] px-5 py-16 md:px-8 md:py-24"
    >
      <header className="reveal max-w-[640px]">
        <p className="text-xs uppercase tracking-[0.3em] text-text-muted">{eyebrow}</p>
        <h2 className="mt-3 font-display text-4xl font-light italic text-text-primary md:text-5xl">
          {title}
        </h2>
        {lede && <p className="mt-4 text-text-secondary">{lede}</p>}
      </header>
      <div className="mt-10 grid grid-cols-12 gap-5">{children}</div>
    </section>
  )
}
